import { useState, useEffect } from 'react'
import ProductCard from '../components/ProductCard'
import { productsService } from '../services/products'

const HomePage = () => {
  const [products, setProducts] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true)
        const data = await productsService.getAll()
        setProducts(data)
        setError(null)
      } catch (err) {
        console.error('Error fetching products:', err)
        setError('Failed to load products')
      } finally {
        setLoading(false)
      }
    }

    fetchProducts()
  }, [])

  if (loading) {
    return <div className="loading" />
  }

  if (error) {
    return (
      <div className="empty-state">
        <h2>{error}</h2>
      </div>
    )
  }

  if (products.length === 0) {
    return (
      <div className="empty-state">
        <h2>No products available</h2>
      </div>
    )
  }

  return (
    <>
    <div className="products-grid">
      {products.map((product) => (
        <ProductCard key={product.id} product={product} />
      ))}
    </div>
    </>
  )
}

export default HomePage
